// Copyright (c) Meta Platforms, Inc. and affiliates.
// All rights reserved.

// This source code is licensed under the license found in the
// LICENSE file in the root directory of this source tree.

export interface modelScaleProps {
  samScale: number;
  height: number;
  width: number;
}

export interface modelInputProps {
  x: number;
  y: number;
  clickType: number;
}

export interface modeDataProps {
  clicks?: Array<modelInputProps>;
  modelScale: modelScaleProps;
}

export interface ToolProps {
  handleMouseMove: (e: any) => void;
}

export interface RGBAColors {
  r: number;
  g: number;
  b: number;
  a: number;
}

export interface DesignImage {
  src: string;
  key: string;
  lastModified: Date
  previous?: DesignImage
  eTag?: string;
  isProcessed?: boolean;
  formattedSize?: string;
  embeddings?: ArrayBuffer;
  name?: string;
}

export interface ApiResponse<T> {
  creditsRemaining: number;
  output: T;
}

export class NotEnougCreditsError extends Error {
  constructor(message: string) {
    super(message);

    // Set the prototype explicitly, as it's not set automatically in some environments (e.g., when transpiling to ES5)
    Object.setPrototypeOf(this, NotEnougCreditsError.prototype);

    // Optionally, you can set a custom name for your error
    this.name = 'NotEnougCreditsError';
  }
}

export class SubscriptionRequiredError extends Error {
  constructor(message: string) {
    super(message);

    // Set the prototype explicitly, as it's not set automatically in some environments (e.g., when transpiling to ES5)
    Object.setPrototypeOf(this, SubscriptionRequiredError.prototype);

    // Optionally, you can set a custom name for your error
    this.name = 'SubscriptionRequiredError';
  }
}
